import * as React from 'react'
import {Link} from "gatsby";

const Overlay = () => {
    return (
        <div className="ort">
            <div className="information">
                <div className="image" id="image">
                    <img alt="" className="ort-img dummy" src={"/images/Logo_ODD.svg"}/>                
                </div>
                <div className="row">
                    <div className="col-12">
                        <h2>
                            Tutzing
                        </h2>
                    </div>
                </div>
                <p>
                    Die 1957 gegründete Akademie für Politische Bildung steht stellvertretend für die Bedeutung politischer Bildung und Aufklärung in der Demokratie, wie die Evangelische Akademie (gegründet 1947) für die Bedeutung des demokratischen Diskurses steht. Tutzing ist somit ein Ort des demokratischen Diskurses und der politischen Bildung.
                </p>
            </div>
                <Link to="/neue-Orte/" className='ort-text icon-arrow-right load-infobox'>
                Mehr erfahren
            </Link>

        </div>
    )
}

export default Overlay

